import script from "./PaginatedListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginatedListView.vue?vue&type=script&lang=ts&setup=true"

import "./PaginatedListView.vue?vue&type=style&index=0&id=3b7f8258&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7f8258"]])

export default __exports__